const LOGIN_ACTIONS = {
  //LOGOUT
  USER_LOGOUT: "USER_LOGOUT",
  USER_LOGOUT_SUCCESS: "USER_LOGOUT_SUCCESS",
  USER_LOGOUT_FAIL: "USER_LOGOUT_FAIL",
  // login with KEYCLOAK
  LOGIN_WITH_KEYCLOAK: "LOGIN_WITH_KEYCLOAK",
  LOGIN_WITH_KEYCLOAK_SUCCESS: "LOGIN_WITH_KEYCLOAK_SUCCESS",
  LOGIN_WITH_KEYCLOAK_FAIL: "LOGIN_WITH_KEYCLOAK_FAIL",
};
export default LOGIN_ACTIONS;
